<template>
  <div class="pageview">
    <el-form
      :model="queryParams"
      ref="queryForm"
      size="small"
      :inline="true"
      v-show="showSearch"
      label-width="120px"
    >
      <el-form-item label="姓名" prop="name">
        <el-input
          v-model="queryParams.name"
          placeholder="请输入姓名"
          learable
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item label="手机号" prop="userId">
        <el-input
          v-model="queryParams.userId"
          placeholder="请输入手机号"
          learable
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item label="日期范围">
        <el-date-picker
          v-model="dateRange"
          style="width: 240px"
          value-format="yyyy-MM-dd"
          type="daterange"
          range-separator="-"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          @change="dateChange"
        ></el-date-picker>
      </el-form-item>

      <el-form-item>
        <el-button
          type="primary"
          icon="el-icon-search"
          size="mini"
          @click="queryFun"
          >查询</el-button
        >
        <el-button icon="el-icon-refresh" size="mini" @click="resetQuery"
          >重置</el-button
        >
        <el-button
          type="primary"
          icon="el-icon-search"
          size="mini"
          @click="$refs.searchInfo.addCreateForm(platForm)"
          >人脸搜索</el-button
        >

        <el-button
          type="primary"
          plain
          icon="el-icon-plus"
          size="mini"
          @click="
            $refs.addFaceDatabase.addCreateForm(oriApi, userName, platForm)
          "
          >新增</el-button
        >
      </el-form-item>
    </el-form>
    <div class="faceDatabase">
      <div
        class="faceDatabase_box"
        v-for="(item, index) in dataList"
        :key="index"
        @click="$refs.details.addCreateForm(item)"
      >
        <!-- <image-preview :src="item.url" :width="100" :height="100" /> -->
        <div class="faceDatabase_box_imgBox">
          <img :src="item.url" class="faceDatabase_box_img" alt="" />
        </div>
        <span class="faceDatabase_box_name">{{ item.userName }} <span class="faceDatabase_box_phone">( {{ item.userPhone }})</span></span>
        <span class="faceDatabase_box_time">{{ item.createTime }}</span>
        <span class="faceDatabase_box_time" v-if="!searchShow">相似度：{{ item.score }}%</span>
        <div class="faceDatabase_box_btnBox">
          <el-button
            size="mini"
            type="primary"
            round
            plain
            @click.stop="$refs.addFaceDatabase.addFaceForm(item)"
            >新增人脸</el-button
          >
          <!-- <el-button size="mini" type="primary" @click="$refs.addFaceDatabase.addCreateForm(oriApi, userName, platForm)">修改</el-button> -->
          <el-button
            size="mini"
            type="danger"
            round
            plain
            @click.stop="handleDelete(item)"
            >删除</el-button
          >
        </div>
        <!-- <span class="faceDatabase_box_content"></span> -->
      </div>
      <div class="faceDatabase_empty">
        <el-empty description="暂无内容" v-if="dataList.length == 0"></el-empty>
      </div>
    </div>

    <pagination
      v-if="searchShow"
      v-show="total > 0"
      :total="total"
      :page.sync="queryParams.pageNum"
      :limit.sync="queryParams.pageSize"
      @pagination="getList"
    />
    <addFaceDatabase ref="addFaceDatabase" @ok="getList" />
    <detailsInfo ref="details" />
    <searchInfo ref="searchInfo" @ok="handleQuery" />
  </div>
</template>

<script>
import { getfaceLibraryList, faceLibrarydelUser } from "@/api/faceDatabase";
import addFaceDatabase from "@/views/system/faceDatabase/addFaceDatabase";
import detailsInfo from "@/views/system/faceDatabase/details";
import searchInfo from "@/views/system/faceDatabase/searchInfo";
import "@/assets/imgList.css";
export default {
  components: {
    addFaceDatabase,
    detailsInfo,
    searchInfo,
  },
  data() {
    return {
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        platForm: "",
        userId: "",
        beginTime: "",
        name: "",
        endTime: "",
      },
      loading: false,
      total: 0,
      dataList: [],
      showSearch: true,
      platForm: "",
      userName: "",
      oriApi: "",
      faceImg: "",
      searchShow: true,
      dateRange: [],
    };
  },
  created() {},
  mounted() {
    this.userName = this.$route.query.userName;
    this.platForm = this.$route.query.platForm;
    this.oriApi = this.$route.query.oriApi;
    this.queryParams.platForm = this.platForm;
    this.getList();
  },
  methods: {
    getList() {
      getfaceLibraryList(this.queryParams).then((response) => {
        const result = response.data.data;
        console.log(result);
        result.list.forEach((item) => {
          if (item.userInfo) {
            item.userInfo = JSON.parse(item.userInfo);
            item.userName = item.userInfo.name;
            item.userPhone = item.userInfo.id;
          }
        });
        this.dataList = result.list;
        this.total = result.total;
      });
    },
    dateChange(val) {
      if (val) {
        this.queryParams.beginTime = val[0];
        this.queryParams.endTime = val[1];
      } else {
        this.queryParams.beginTime = "";
        this.queryParams.endTime = "";
      }
    },
    queryFun() {
      this.queryParams.pageNum = 1;
      this.getList();
    },
    toTwoDecimalRegex(value) {
    let num = parseFloat(value);
    return num.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0];
},
    /** 搜索按钮操作 */
    handleQuery(list) {
      console.log(list);
      this.searchShow = false;
      list.forEach((item) => {
          if (item.userInfo) {
            item.userInfo = JSON.parse(item.userInfo);
            item.userName = item.userInfo.name;
            item.userPhone = item.userInfo.id;
          }
          item.score = this.toTwoDecimalRegex(item.score * 1);
        });
      this.dataList = list;
    },
    handleDelete(row) {
      const ids = row.id;
      this.$modal
        .confirm('是否确认删除编号为"' + ids + '"的数据项？')
        .then(function () {
          return faceLibrarydelUser({
            id: ids,
          });
        })
        .then(() => {
          this.getList();
          this.$modal.msgSuccess("删除成功");
        })
        .catch(() => {});
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.queryParams = {
        pageNum: 1,
        pageSize: 10,
        platForm: this.platForm,
        userId: "",
        beginTime: "",
        endTime: "",
      };
      this.dateRange = [];
      this.queryFun();
    },
  },
};
</script>
<style>
.faceDatabase_box_phone{
  font-size: 12px;
  font-weight: 500;
  color: #666666;
}
</style>

